import { Carousel, Col, Container, Row } from "react-bootstrap";
import "./headercarousel.css";

function HCarousel() {
    return (
        <div>
            <Container fluid className="carousel-container px-5 py-3">
                <Row>
                    <Col md={6}>

                        <Carousel style={{ height: "400px" }}>
                            <Carousel.Item>
                                <div className="pt-5  text1-container">
                                    <h1 >
                                        Asli Taleem <br />
                                        Seekho, Wo <br />
                                        bhi <br />
                                        Bilkul Muft
                                    </h1>

                                </div>
                            </Carousel.Item>
                            <Carousel.Item>
                                <div className="pt-4 p-5  second2-container">
                                    <ul>
                                        <li>We’re not Free, we’re MUFT.</li>
                                        <li>No Shakespeare & No Mr. Chips.</li>
                                        <li>ASLI/NASLI Taleem & Open 24/7.</li>
                                        <li>Pakistan's 2nd Best University.</li>
                                        <li>Full Courses, up to 51 hours long.</li>
                                        <li>Available in every home of Pakistan.</li>
                                        <li>Real-World Assessment Instead of Exams.</li>
                                        <li>20+ IT Based Subjects (Updated Regularly).</li>
                                        <li>No minimum age, just a PC/laptop is required.</li>
                                        <li>Accredited by the only accreditation <br></br>that matters, the workplace.</li>


                                    </ul>

                                </div>
                            </Carousel.Item>
                        </Carousel>

                    </Col>

                    <Col >
                        <img
                            src={require("../src/assest/3d-business-woman.png")} style={{ width: 500, height: 400 }}
                          
                        />
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default HCarousel;
